import { useToast } from '@cad-arc';
import { useEffect, useState } from 'react';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useDexDeviceIdentificationErrorState } from './use-show-dex-device-identification-error';

export function useDexDeviceIdentificationErrorToast({
    isToastEnabled = true,
}: {
    isToastEnabled?: boolean;
} = {}) {
    const { showDexDeviceIdentificationError } = useDexDeviceIdentificationErrorState();
    const { dataExchange } = useEnabledFeatures();
    const [
        haveShownDexDeviceIdentificationError,
        setHaveShownDexDeviceIdentificationError,
    ] = useState<boolean>(false);
    const toast = useToast();
    useEffect(() => {
        if (
            isToastEnabled &&
            dataExchange &&
            showDexDeviceIdentificationError &&
            !haveShownDexDeviceIdentificationError
        ) {
            toast({
                description: (
                    <>
                        <strong>Data Exchange Error: Device Identification.</strong>
                        <br />
                        The Mark43 Desktop Integration Service is not installed or not running. Make
                        sure DIS is functioning properly and contact an administrator if this error
                        persists.
                    </>
                ),
                status: 'default',
                position: 'top',
                duration: 100 * 1000,
            });
            setHaveShownDexDeviceIdentificationError(true);
        }
    }, [
        isToastEnabled,
        showDexDeviceIdentificationError,
        haveShownDexDeviceIdentificationError,
        toast,
        dataExchange,
    ]);
}
